import { Col, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../reduxToolkit/hooks';

import LogoWrapper from './widgets/LogoWrapper';
import SearchBar from './widgets/SearchBar';
import SearchInput from './widgets/SearchInput';
import FullScreen from './widgets/FullScreen';
import Notification from './widgets/Notification';
import Bookmark from './widgets/bookmark';
import Message from './widgets/Message';
import Cart from './widgets/cart';
import Mode from './widgets/Mode';
// import Language from "./widgets/Language";
import Profile from './widgets/Profile';
import { useEffect, useRef, useState } from 'react';
import { logout } from '../../reduxToolkit/reducers/layout/authSlice';
import SimpleModal from '../../components/uiKits/modal/basicModal/SimpleModal';
import LogoutNotification from './widgets/LogoutNotification';
import Language from './widgets/Language';
import FeedBack from './widgets/Feedback';
import { capture } from '../../services/analytics';
import { clearPinned } from '../../reduxToolkit/reducers/layout/layoutSlice';
import { logoutUser } from '../../services/api';
import PlatformPauseNotice from '../PlatformPauseNotice';
import './header.scss';

const Header = () => {
  const { sideBarToggle } = useAppSelector((state) => state.themeCustomizer);
  const headerRef = useRef<HTMLDivElement>(null);
  const [openLogoutNotification, setOpenLogoutNotification] = useState(false);
  const { isAuthenticated, email } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;

    const syncHeight = () => {
      document.documentElement.style.setProperty(
        '--page-header-height',
        `${Math.ceil(header.getBoundingClientRect().height)}px`,
      );
    };

    syncHeight();
    const observer = new ResizeObserver(syncHeight);
    observer.observe(header);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty('--page-header-height');
    };
  }, []);

  const handleLogout = async () => {
    await capture('auth_logout', { reason: 'manual' });
    await localStorage.removeItem('pinned');
    dispatch(clearPinned());
    await logoutUser(email);
    dispatch(logout());
  };
  return (
    <>
      {' '}
      <div ref={headerRef} className={`page-header ${sideBarToggle ? 'close_icon' : ''}`}>
        <Row className="header-wrapper m-0">
          <LogoWrapper />
          {/* <SearchBar /> */}
          <Col
            xs="auto"
            lg="7"
            md="6"
            className="nav-right box-col-6 pull-right right-header p-0 ms-auto"
          >
            <ul className="nav-menus">
              {/* <SearchInput /> */}
              {/* <FullScreen /> */}
              {/* <Notification /> */}
              {/* <Bookmark /> */}
              {/* <Message /> */}
              {/* <Cart /> */}
              <FeedBack />
              <Mode />
              <Language />
              {isAuthenticated && <Profile setOpenLogoutNotification={setOpenLogoutNotification} />}
            </ul>
          </Col>
        </Row>
      </div>
      <PlatformPauseNotice />
      <SimpleModal isOpen={openLogoutNotification} close={() => setOpenLogoutNotification(false)}>
        <LogoutNotification
          logout={() => handleLogout()}
          cancel={() => setOpenLogoutNotification(false)}
        />
      </SimpleModal>
    </>
  );
};

export default Header;
